<template>
  <v-app>
    <div>
      <v-app-bar color="color_thead" dark>
        <img
          class="d-none d-sm-flex"
          src="../src/assets/logo.svg"
          alt="/"
          style="max-width: 300px"
        />
        <v-spacer class="d-none d-sm-flex" />
        <template v-if="user && user.is_active">
          <v-btn icon @click="go('home')">
            <v-icon>mdi-home</v-icon>
          </v-btn>
          <v-btn icon @click="go('rob')">
            <v-icon>mdi-bank</v-icon>
          </v-btn>
          <template v-if="user.is_create_user">
            <v-btn icon @click="go('user')">
              <v-icon>mdi-account-multiple</v-icon>
            </v-btn>
          </template>
          <template v-if="user.is_carte">
            <v-btn
              :class="user.carte_link ? 'red' : ''"
              icon
              @click="go('carte')"
            >
              <v-icon>mdi-cards-outline</v-icon>
            </v-btn>
          </template>
          <v-spacer class="d-flex d-sm-none" />
          <v-menu open-on-click bottom min-width="200px" offset-y>
            <template #activator="{ on, attrs }">
              <v-avatar
                color="color_action"
                v-bind="attrs"
                class="ml-2"
                v-on="on"
              >
                <span class="white--text text-h5">{{ initial() }}</span>
              </v-avatar>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-row>
                    <v-col> {{ user.first_name }} {{ user.last_name }}</v-col>
                    <v-col class="text-right">
                      <v-btn color="color_action" text @click="reset()">
                        <v-icon class="ml-2"> mdi-export</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-else>
          <v-btn icon @click="go('login')">
            <v-icon class="white--text"> mdi-account</v-icon>
          </v-btn>
        </template>
      </v-app-bar>
    </div>

    <v-main class="background_home">
      <v-overlay :value="userIsLoading">
        <v-progress-circular indeterminate size="100" />
      </v-overlay>
      <v-container fluid v-if="!userIsLoading">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { userMixin } from "@/mixins/user";
import { mapGetters } from "vuex";
import jwt_decode from "jwt-decode";

export default {
  name: "App",
  mixins: [userMixin],
  mounted() {
    const access_token = this.$cookies.get("access_token");
    if (access_token) this.userRetrieve();
  },
  computed: {
    ...mapGetters({
      userIsLoading: "user/current/isLoading",
    }),
  },
  methods: {
    initial() {
      if (this.user && this.user.is_active) {
        return this.user.first_name[0] + this.user.last_name[0];
      }
    },
    reset() {
      this.resetUser();
      this.$cookies.remove("refresh_token");
      this.$cookies.remove("access_token");
      if (this.$route.name !== "logout") this.$router.push({ name: "logout" });
    },
    go(route) {
      if (this.$route.name !== route) this.$router.push({ name: route });
    },
    ready: function () {
      const f = this.reset;
      setInterval(function () {
        const refresh_token = this.$cookies.get("refresh_token");
        if (refresh_token !== null) {
          const decoded = jwt_decode(refresh_token);
          if (Date.now() >= decoded.exp * 1000) {
            f();
          }
        }
      }, 10000);
    },
  },
};
</script>
